


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { User, UserRole, UserRoleId } from '@/types/user';
import UsersService from '@/mixins/users.service';

@Component({
  mixins: [ UsersService ],
})
export default class UsersTable extends (UsersService) {
  private headers = [
    {
      text: 'User/Email',
      align: 'left',
      value: 'email',
    },
    {
      text: 'User Name',
      align: 'left',
      value: 'name',
    },
    {
      text: 'Roles',
      align: 'left',
      value: 'roles',
    },
    {
      text: 'Actions',
      value: 'action',
      sortable: false,
    },
  ];

  private onEditUserClick(user: User): Promise<any> {
    return this.$store.dispatch('addEditUser/showModal', user);
  }

  private onEditUserRulesClick(user: User): Promise<any> {
    return this.$store.dispatch('addEditUser/showRulesModal');
  }

  private created(): void {
    this.$store.dispatch('userRoles/update');
    this.$store.dispatch('users/updateUsers', { force: true });
  }

}
